import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  OrganizationTreeView: {
    '&__organization': {
      height: '100%',
      borderLeft: `3px solid ${theme.palette.primary.main}`,
      marginLeft: '35px',
      zIndex: 5,
      '&__border': {
        '&__bottom-left': {
          borderBottom: `3px solid ${theme.palette.primary.main}`,
          borderLeft: `3px solid ${theme.palette.primary.main}`,
          borderBottomLeftRadius: '20px',
          height: '50%',
        },
        '&__end': {
          borderBottom: `3px solid ${theme.palette.primary.main}`,
          borderLeft: `3px solid ${theme.palette.primary.main}`,
          height: '50%',
          marginLeft: '35px',
          borderBottomLeftRadius: '20px',
        },
      },
      '&--border-left': {
        borderLeft: `3px solid ${theme.palette.primary.main}`,
      },
      '&--margin-left': {
        marginLeft: '-3px',
      },
      '&--padding-left': {
        paddingLeft: '35px',
      },
    },
    '&__title': {
      '&--font-size': {
        fontSize: 14,
      },
    },
    '&__timeline': {
      padding: 'initial',
      height: '100%',
      '&:before': {
        padding: 'initial',
      },
      '&--end': {
        height: '50%',
      },
    },
  },
}));
